export const searchOptions = [
  {
    value: "barcode",
    title: "Barcode",
  },
  {
    value: "date",
    title: "Quarantined At",
  },
];
